import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { GridRowId } from "@mui/x-data-grid";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { AssetAttrs } from "../../interfaces/orion";
import ExportMenu from "../Orion/ExportMenu";
import { useDialogs } from "../useDialogs";
import DeleteAssetsDialog from "../useDialogs/DeleteAssetDialog";
import useSession from "../useSession/useSession";
import PageHeader from "./PageHeader";
import PageHeaderToolbar from "./PageHeaderToolbar";

function AssetListingPageToolbar({
  selection,
  assets,
}: {
  selection: readonly GridRowId[];
  assets: AssetAttrs[];
}) {
  const dialogs = useDialogs();
  const session = useSession();
  const navigate = useNavigate();
  const selectedAssetsWorkspaces = assets
    .filter((asset) => selection.includes(asset._id))
    .map((asset) => asset.workspace_id);
  return (
    <PageHeaderToolbar>
      {(session?.OrionContributorGroups?.length ?? 0) > 0 && (
        <Button
          disabled={
            selection.length < 1 &&
            selectedAssetsWorkspaces.every((workspace_id) =>
              session?.OrionContributorGroups.includes(workspace_id)
            )
          }
          variant="contained"
          color="error"
          className="ml-5"
          onClick={async () => {
            await dialogs.open(DeleteAssetsDialog, selection);
          }}
        >
          <Delete />
          Supprimer
        </Button>
      )}
      <ExportMenu
        processingIds={
          assets
            .filter(
              (asset) => selection.includes(asset._id) && !!asset.processing
            )
            .map((asset) => asset.processing?._id) as string[]
        }
        disabled={selection.length < 1}
      />

      <Button
        variant="contained"
        className="ml-5"
        onClick={() => navigate("/orion/asset/new")}
      >
        <Add />
        Nouveau dossier
      </Button>
    </PageHeaderToolbar>
  );
}
function AssetListingHeader({
  selection,
  assets,
}: {
  selection: readonly GridRowId[];
  assets: AssetAttrs[];
}) {
  const PageToolbarComponent = useCallback(
    () => <AssetListingPageToolbar selection={selection} assets={assets} />,
    [selection, assets]
  );

  return (
    <PageHeader breadcrumbs={[]} slots={{ toolbar: PageToolbarComponent }} />
  );
}

export default AssetListingHeader;
